import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'pf-comn-filename',
    templateUrl: './pf-comn-filename.component.html',
})
export class PfComnFilenameComponent implements OnInit, OnDestroy {
    @Input() public fileName: string;
    @Output() public fileNameChange: EventEmitter<string> = new EventEmitter();

    private onDestroy$ = new Subject<void>();
    public fcFileName = new FormControl(null);

    ngOnInit(): void {
        this.fcFileName.setValue(this.fileName);
        this.fcFileName.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe((value: string) => this.fileNameChange.emit(value));
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
